
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/wiki",
      function () {
        return require("private-next-pages/community/wiki/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/wiki"])
      });
    }
  